import FilaCategoria from "./FilaCategoria";
import styles from "../MapaCalor.module.scss";

const TablaCalor = ({ data, maxContactos }) => {
  if (data.length === 0) {
    return <p className="text-muted text-center mt-4">No hay datos para mostrar</p>;
  }

  return (
    <div className={styles.calorTable}>
      {data.map((cat) => (
        <FilaCategoria key={cat.id} categoria={cat} maxContactos={maxContactos} />
      ))}
    </div>
  );
};

export default TablaCalor;
